import {
    Checkbox,
    FormControlLabel,
    Select,
    FormControl,
    MenuItem,
} from '@mui/material';
import { BarChart } from '@mui/icons-material';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { LinePlot, MarkPlot } from '@mui/x-charts/LineChart';
import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsGrid } from '@mui/x-charts/ChartsGrid';
import { ChartsTooltip } from '@mui/x-charts/ChartsTooltip';
import { ChartsLegend } from '@mui/x-charts/ChartsLegend';
import { H6, Body2, Body1 } from "../../../../../themes/typography"

export default function SalesSummary({
    timeframe,
    onTimeFrameChange,
    showTicketSoldChart,
    showRevenueGeneratedChart,
    showTotalRevenueChart,
    onShowTicketSoldChart = () => { },
    onShowRevenueGeneratedChart = () => { },
    onShowTotalRevenueChart = () => { },
    dataset
}) {

    // const series = [
    //     {
    //         type: 'line',
    //         dataKey: 'totalRevenue',
    //         yAxisId: 'rightAxis',
    //         color: 'var(--success-secondary-color)',
    //         label: 'Total Revenue Generated',
    //         hidden: !showTotalRevenueChart
    //     },
    //     {
    //         type: 'bar',
    //         dataKey: 'tickets',
    //         color: 'var(--secondary-color)',
    //         yAxisId: 'leftAxis',
    //         label: 'Tickets Sold'
    //     },
    //     {
    //         type: 'bar',
    //         dataKey: 'revenue',
    //         color: 'var(--tertiary-color)',
    //         yAxisId: 'rightAxis',
    //         label: 'Revenue Generated'
    //     }
    // ];

    const series = [];

    if (showTotalRevenueChart) {
        series.push({
            type: 'line',
            dataKey: 'totalRevenue',
            yAxisId: 'rightAxis',
            color: 'var(--success-secondary-color)',
            label: 'Total Revenue Generated',
        });
    }

    if (showTicketSoldChart) {
        series.push({
            type: 'bar',
            dataKey: 'tickets',
            yAxisId: 'leftAxis',
            color: 'var(--secondary-color)',
            label: 'Tickets Sold',
        });
    }

    if (showRevenueGeneratedChart) {
        series.push({
            type: 'bar',
            dataKey: 'revenue',
            yAxisId: 'rightAxis',
            color: 'var(--tertiary-color)',
            label: 'Revenue Generated',
        });
    }

    // console.log("Dateset -> ", JSON.stringify(dataset, null, 2));

    const formatXAxisValue = (value) => {
        if (timeframe === 'daily') {
            // Format: "01th Nov\n2025"
            const [datePart, yearPart] = value.split(' ');
            return `${datePart}\n${yearPart}`;
        } else if (timeframe === 'weekly') {
            // Format: "Week 1\n2nd Nov 2025 - 8th Nov 2025"
            const weekMatch = value.match(/Week (\d+) — (.+)/);
            if (weekMatch) {
                return `Week ${weekMatch[1]}\n${weekMatch[2]}`;
            }
            return value;
        }
        // Monthly - keep as is
        return value;
    };

    return (
        <div className="event-sales-summary-container">
            <div className='event-sales-summary-wrapper'>

                <div className="event-sales-summary-title">
                    <H6 fontWeight={600}>
                        Sales Summary
                    </H6>
                </div>

                <div className="event-sales-summary-content">

                    {dataset?.length > 0 && (
                        <div className="sales-summary-chart-view-changer">

                            <div className='conditional-show-charts'>
                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            // disabled={!dataset || dataset.length === 0}
                                            checked={showTicketSoldChart}
                                            onChange={onShowTicketSoldChart}
                                            sx={{
                                                color: 'var(--quaternary-color)',
                                                '&.Mui-checked': {
                                                    color: 'var(--secondary-color)'
                                                }
                                            }}
                                        />)
                                    }
                                    label={<Body2>Tickets Sold</Body2>}
                                />

                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            checked={showRevenueGeneratedChart}
                                            // disabled={!dataset || dataset.length === 0}
                                            onChange={onShowRevenueGeneratedChart}
                                            sx={{
                                                color: 'var(--quaternary-color)',
                                                '&.Mui-checked': {
                                                    color: 'var(--secondary-color)'
                                                }
                                            }}
                                        />
                                    )}
                                    label={<Body2>Revenue Generated</Body2>}
                                />

                                <FormControlLabel
                                    control={(
                                        <Checkbox
                                            checked={showTotalRevenueChart}
                                            // disabled={!dataset || dataset.length === 0}
                                            onChange={onShowTotalRevenueChart}
                                            sx={{
                                                color: 'var(--quaternary-color)',
                                                '&.Mui-checked': {
                                                    color: 'var(--secondary-color)'
                                                }
                                            }}
                                        />
                                    )}
                                    label={<Body2>Total Revenue Generated</Body2>}
                                />
                            </div>

                            <div className="switch-chart-time-frame">
                                <FormControl size="small">
                                    <Select
                                        labelId="chart-time-frame-select-label"
                                        id="chart-time-frame-select"
                                        defaultValue={'daily'}
                                        value={timeframe}
                                        // disabled={!dataset || dataset.length === 0}
                                        onChange={(e) => onTimeFrameChange(e.target.value)}
                                        sx={{
                                            minWidth: '150px',
                                            '& .MuiSvgIcon-root': {
                                                color: 'var(--quaternary-color)'
                                            }
                                        }}
                                    >
                                        <MenuItem value={'daily'}>
                                            Daily
                                        </MenuItem>
                                        <MenuItem value={'weekly'}>
                                            Weekly
                                        </MenuItem>
                                        <MenuItem value={'monthly'}>
                                            Monthly
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                        </div>
                    )}

                    <div className="sales-summary-chart-container">

                        {dataset?.length === 0 && (
                            <div className="no-system-alerts">
                                <div className="no-system-alerts-icon">
                                    <BarChart sx={{ fontSize: "3rem" }} color="inherit" />
                                </div>
                                <Body1 fontWeight={400}>
                                    No sales data available.
                                </Body1>
                                <Body2 color="var(--secondary-color)" fontWeight={350}>
                                    Sales data will be displayed here once tickets are sold.
                                </Body2>
                            </div>
                        )}

                        {/* 2nd Nov 2025 -> daily */}
                        {/* Week 1 — 2nd Nov 2025 - 8th Nov 2025 -> weekly */}
                        {/* Nov 2025 -> monthly */}
                        <ResponsiveChartContainer
                            series={series}
                            xAxis={[
                                {
                                    scaleType: 'band',
                                    dataKey: 'period',
                                    label: '',
                                    reverse: false,
                                    valueFormatter: formatXAxisValue
                                },
                            ]}
                            yAxis={[
                                { id: 'leftAxis', reverse: false, label: 'Tickets Sold' },
                                { id: 'rightAxis', reverse: false, label: 'Revenue Generated' },
                                { id: 'rightAxis', reverse: false, label: '' },
                            ]}
                            dataset={dataset}
                            height={400}
                            sx={{
                                padding: '0.5rem 0'
                            }}
                        >
                            <ChartsGrid
                                horizontal
                                sx={{
                                    '& .MuiChartsGrid-horizontalLine': {
                                        stroke: 'var(--divider-color)'
                                    }
                                }}
                            />

                            {/* Tickets Sold (Bar) */}
                            {showTicketSoldChart && (
                                <BarPlot dataKey="tickets" />
                            )}

                            {/* Revenue Generated (Bar) */}
                            {showRevenueGeneratedChart && (
                                <BarPlot dataKey="revenue" />
                            )}

                            {/* Total Revenue Generated (Line + Mark) */}
                            {showTotalRevenueChart && (
                                <>
                                    <LinePlot dataKey="totalRevenue" />
                                    <MarkPlot dataKey="totalRevenue" />
                                </>
                            )}

                            <ChartsXAxis
                                sx={{
                                    '& .MuiChartsAxis-line': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tick': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-label': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        fontSize: '14px',
                                    },
                                    '& .MuiChartsAxis-tickLabel': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                    },
                                }}
                            />

                            <ChartsYAxis
                                axisId="leftAxis"
                                sx={{
                                    '& .MuiChartsAxis-line': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tick': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tickLabel': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        fontSize: '14px',
                                    },
                                    '& .MuiChartsAxis-label': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        transform: 'translate(-25px)',
                                    }
                                }}
                            />

                            <ChartsYAxis
                                axisId="rightAxis"
                                position={!showTicketSoldChart ? 'left' : 'right'}
                                label=''
                                sx={{
                                    '& .MuiChartsAxis-line': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tick': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tickLabel': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        fontSize: '14px',
                                    },
                                    '& .MuiChartsAxis-label': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        transform: !showTicketSoldChart ? 'translate(-25px)' : 'translate(35px)'
                                    },

                                }}
                            />

                            <ChartsYAxis
                                axisId="rightAxis"
                                position={!showTicketSoldChart ? 'left' : 'right'}
                                label='Revenue Generated'
                                sx={{
                                    '& .MuiChartsAxis-line': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tick': { stroke: 'var(--divider-color)' },
                                    '& .MuiChartsAxis-tickLabel': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                    },
                                    '& .MuiChartsAxis-label': {
                                        fill: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                        transform: !showTicketSoldChart ? 'translate(-25px)' : 'translate(35px)'
                                    },

                                }}
                            />

                            <ChartsTooltip
                                sx={{
                                    '& .MuiChartsTooltip-paper': {
                                        backgroundColor: 'var(--gradient-overlay-bg-color-2)',
                                        border: '1px solid var(--divider-color)',
                                        boxShadow: 'none',
                                        color: 'var(--quaternary-color)',
                                        fontFamily: 'var(--secondary-content-font-family)',
                                    },
                                    '& .MuiChartsTooltip-root': {
                                        color: 'var(--quaternary-color)',
                                        background: 'var(--gradient-overlay-bg-color-2)',
                                    }
                                }}
                            />

                            {dataset?.length > 0 && (
                                <ChartsLegend
                                    position={{
                                        horizontal: 'middle',
                                        vertical: 'top',
                                    }}
                                    direction="row"
                                    itemMarkWidth={12}
                                    itemMarkHeight={12}
                                    markGap={8}
                                    labelSpacing={20}
                                />
                            )}

                        </ResponsiveChartContainer>

                    </div>

                </div>
            </div>
        </div>
    )
}